import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //src: 'https://localhost:44320',
    //subDirectory: '',
    //src: 'https://dormitory.thinker.tw',
    //subDirectory: '/Platform',
    src: 'https://pms.nccu.edu.tw',
    subDirectory: '/Platform',
    //loginPage: 'https://portal6.nccu.edu.tw/Login.aspx?ReturnUrl=%2Fsso_app%2FEHouseSSO.aspx&backUrl=https://dormitory.thinker.tw/Login&app=EHouseSSO'
    loginPage: 'https://i.nccu.edu.tw/Login.aspx?ReturnUrl=%2fsso_app%2fEHouseSSO.aspx&backUrl=https://pms.nccu.edu.tw/Login&app=EHouseSSO'
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
